<template>
  <div>
    <app-bar>
      <back-button goBackTo="/account" />
    </app-bar>

    <list-header title="My Cards" />
    <row-label-text
      class="mt-3"
      v-for="rowLabel in rowLabels"
      :key="rowLabel"
      :iconUrl="rowLabel.iconUrl"
      :urlLink="rowLabel.urlLink"
      @click="handleDeleteModal(rowLabel.cardId)"
    >
      <template v-slot:content>
        <div v-if="rowLabel.iconUrl" class="style-icon-size me-3">
          <cardBrandIcon :cardBrand="rowLabel.iconUrl" class="" />
        </div>
        <span class="ms-1 flex-grow-1 text-start my-auto scss-large-font">{{
          rowLabel.title
        }}</span>
      </template>
    </row-label-text>
  </div>
</template>

<script>
import {
  defineAsyncComponent,
  markRaw
} from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import RowLabelText from "@/components/RowLabelText.vue";
import ListHeader from "@/components/ListHeader.vue";
import { deleteSavedCard } from "@/services/stripe";
import CardBrandIcon from "@/components/onlinePayment/CardBrandIcon";
import BackButton from "@/components/button/BackButton";
import AppBar from "@/components/AppBar.vue";
import { openModal, closeModal } from "@/store/modal";

export default {
  name: "MyAccount",
  components: {
    ListHeader,
    RowLabelText,
    CardBrandIcon,
    BackButton,
    AppBar,
  },
  data() {
    return {
      rowLabels: [
        {
          title: "Add New Card",
          urlLink: "/account/card/add",
          cardId: null,
        },
      ],
    };
  },
  methods: {
    showCards() {
      this.cards.forEach((data) => {
        const { id, card } = data;
        const { brand, last4 } = card;
        this.rowLabels.splice(this.rowLabels.length - 1, 0, {
          cardId: id,
          title: `**** **** **** ${last4}`,
          iconUrl: brand,
        });
      });
    },
    handleDeleteModal(cardId) {
      if (cardId) {
        this.cardId = cardId;

        openModal(
          {
            id: "deleteCardModal",
            title: "Delete Card",
          },
          markRaw(defineAsyncComponent(() => import("@/components/ModalContentComponent.vue"))),
          {
            content: "Are you sure to delete this card?",
          },
          {},
          [
            {
              text: 'No',
              clickFn: () => {
                closeModal();
              },
            },
            {
              text: 'Yes',
              class: 'scss-button-red',
              clickFn: this.deleteCard,
            }
          ]
        );
      }
    },
    async deleteCard() {
      try {
        this.showLoading(true);
        await deleteSavedCard(this.cardId);
        let index = this.rowLabels.findIndex((rawLabel) => {
          return rawLabel.cardId === this.cardId;
        });
        this.rowLabels.splice(index, 1);
        this.showLoading(false);
        closeModal();
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions(["getSavedCards", "deleteSavedCard"]),
    ...mapMutations(["showLoading"]),
  },
  computed: {
    ...mapGetters(["cards"]),
  },
  created() {
    this.getSavedCards().then(() => {
      this.showCards();
    });
  },
};
</script>

<style scoped>
.style-icon-size {
  height: 25px;
  width: 25px;
}
</style>
